import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const painPoints = [{
  icon: '😤',
  text: 'Comprás packs de planificaciones genéricos que no sirven para tus alumnos reales'
}, {
  icon: '⏰',
  text: 'Pasás horas del domingo planificando cuando podrías descansar'
}, {
  icon: '💸',
  text: "Gastás en PDFs de 'especialistas' que son copias de ChatGPT mal hecho"
}, {
  icon: '😰',
  text: 'Querés usar IA pero no sabés cómo pedirle lo que necesitás'
}, {
  icon: '📚',
  text: 'Reutilizás planificaciones viejas porque no tenés tiempo de crear material nuevo'
}, {
  icon: '🔄',
  text: 'Buscás, comprás, te decepcionás, repetís. El ciclo no para'
}];
export function PainSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section className="w-full bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-148">
      <div ref={ref} className={`max-w-[800px] mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-149">
        <div className="text-center mb-8" data-id="element-150">
          <span className="inline-block font-montserrat font-bold text-gold text-sm tracking-widest uppercase mb-3" data-id="element-151">
            ¿TE SUENA FAMILIAR?
          </span>
          <h2 className="font-playfair font-bold text-2xl sm:text-[36px] leading-[1.2] text-navy" data-id="element-152">
            Sos Docente. Trabajás Más que Nadie. Y Seguís Pagando por Material
            que Termina en una Carpeta de Drive
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8" data-id="element-153">
          {painPoints.map((point, index) => <div key={index} className="bg-white border border-[#E8EEF4] rounded-xl p-4 shadow-[0_2px_12px_rgba(0,0,0,0.05)] flex items-start gap-3 text-left" data-id="element-154">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-155">
                {point.icon}
              </span>
              <p className="font-inter text-sm text-gray-600 leading-snug" data-id="element-156">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-157">
          <p className="font-inter font-bold text-lg text-electric italic" data-id="element-158">
            "El problema no sos vos. Es que nadie te enseñó a usar la IA
            correctamente para tu trabajo real."
          </p>
        </div>
      </div>
    </section>;
}